export const apiPath = process.env.REACT_APP_WEB_SERVER_CONNECTION_URL;
export const deviceServiceName = process.env.REACT_APP_DEVICE_SERVER_CONNECTION_SERVICE;